"use client";

import Link from "next/link";
import type { ComponentPropsWithoutRef } from "react";

import { useAuth } from "@/components/providers/auth-provider";

/**
 * A "Host a contest" door (`EX-HST01`, Wave 15 decision 2): a visitor who is
 * not signed in reads what hosting costs on `/contests/host` first; a signed-in
 * one goes straight to their contests, as every such button did before.
 *
 * The static page renders the signed-out address (the session is known only
 * in the browser), and it turns into the dashboard's once the account is.
 * The label comes from the caller, usually a server component's translation.
 */
export function HostContestLink({
  locale,
  ...props
}: { locale: string } & Omit<ComponentPropsWithoutRef<typeof Link>, "href">) {
  const { isAuthenticated } = useAuth();
  return <Link href={isAuthenticated ? `/${locale}/dashboard/contests` : `/${locale}/contests/host`} {...props} />;
}
